import React from 'react';
import Helmet from 'react-helmet';
import View from '../components/View';
import PostsListView from '../components/PostsListView';
import ContactView from '../components/ContactView';
import FooterView from '../components/FooterView';

const IndexPage = (props) => {
  const {data} = props;
  const filters = [
    {
      title: 'Technologie',
      value: 'technologie'
    }, {
      title: 'Vie de l\'agence',
      value: 'vie-de-l-agence'
    }, {
      title: 'Nos clients',
      value: 'nos-clients'
    }
  ];
  return (
    <div>
      <Helmet
        title="Blog : Technologie - Com des Lézards"
        meta={[{
          name: 'description',
          content: `Tous les articles de notre blog concernant les technologies avec lesquels nous travaillons. Des retours d'expérience ou des infos sur des technologies comme Prestashop, Gatsby.js, React ou des outils pour le référencement par exemple.`
        }
      ]}/>
      <View colorMode="3">
        <PostsListView
          data={data}
          title="Nous partageons avec vous"
          titleColor="#dedee3"
          subtitle="Derniers articles"
          subtitleColor="#4d12c7"
          activeFilter="technologie"
          filters={filters}/>
        <ContactView/>
        <FooterView/>
      </View>
    </div>

  );
};

export default IndexPage;

export const query = graphql `
  query articles_technologie {
    allDatoCmsArticle(sort: {fields:[publicationDate], order:DESC}, filter: {
      articleType: {eq: "article"},
      tag: {eq: "technologie"}
    }) {
      ...previewArticle
    }
  }
  `;



// WEBPACK FOOTER //
// ./src/pages/blog-technologie.jsx